import { createPopupReducerAndActionCreators } from '@paragon/popup-state';

import type { PopupOptionsMap } from '../actions/dialogActions';

export const { popupReducer: popup, showPopup } = createPopupReducerAndActionCreators<PopupOptionsMap>();
